import { render, screen } from '@testing-library/react'
import App from './App'

jest.mock('./screens/HomeScreen', () => {
  const React = require('react')
  return ({ showAssociationCampaignPopup }) => React.createElement('div', {
    'data-testid': 'home-screen',
    'data-campaign-popup': String(showAssociationCampaignPopup)
  })
})
jest.mock('./components/Footer', () => () => null)
jest.mock('./components/Navigation', () => () => null)
jest.mock('./components/BackToTop', () => () => null)
jest.mock('./utilities/ScrollToTop', () => () => null)

test.each(['/', '/asociacion'])('shows the campaign popup when loading %s directly', (path) => {
  window.history.pushState({}, 'Test page', path)

  render(<App />)

  expect(screen.getByTestId('home-screen').getAttribute('data-campaign-popup')).toBe('true')
})
